import * as React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
//export const StyledTableCellClass = styled(TableCell)(({ theme, Align = 'left', PaddingBody = '6px 16px' }) => ({
export const HtmlTooltip = styled(({ className, ...props }) => (<Tooltip {...props} classes={{ popper: className }} />))(({ theme, maxWidth = '220px' }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: maxWidth,
        //fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));